import apiClient from "@/shared/api/apiClient2";

export const getInheritanceList = async (params) => {
  try {
    const { data } = await apiClient.get("/inheritance/", {
      params,
    });
    return data;
  } catch (e) {
    console.error("getInheritanceList failed", e);
  }
};

export const getInheritanceItem = async (id) => {
  try {
    const { data } = await apiClient.get(`/inheritance/detail/${id}/`);
    return data;
  } catch (e) {
    console.error("getInheritanceItem failed", e);
  }
};

export const createInheritance = async (code, params) => {
  const result = await apiClient.post(`/inheritance/submit/${code}`, {
    ...params,
  });
  return result.data;
};

export const updateInheritance = async (id, params) => {
  const result = await apiClient.put(
    `/inheritance/${id}/`,
    {
      ...params,
    },
    {
      metaData: { isNotificationDisabled: true },
    }
  );
  return result.data;
};

export const searchDeceasedPerson = async (id, body) => {
  const result = await apiClient.post(
    `/inheritance/check-inheritance/${id}`,
    body,
    {
      metaData: { isNotificationDisabled: true },
    }
  );
  return result.data;
};

export const searchInheritance = async (id, body) => {
  const result = await apiClient.post(
    `/inheritance/check-testament/${id}`,
    body,
    {
      metaData: { isNotificationDisabled: true },
    }
  );
  return result.data;
};

export const checkStatement = async (id, body) => {
  const result = await apiClient.post(
    `/inheritance/check-statement/${id}`,
    body,
    {
      metaData: { isNotificationDisabled: true },
    }
  );
  return result.data;
};

export const updateInheritanceNote = async (id, note) => {
  const { data } = await apiClient.put(`/inheritance/${id}/note`, {
    note,
  });
  return data;
};

export const updateInheritanceDescription = async (id, description) => {
  const { data } = await apiClient.put(`/inheritance/${id}/description`, {
    description,
  });
  return data;
};

export const changeStatusInheritance = async (id, params) => {
  const { data } = await apiClient.put(`/inheritance/${id}/status`, {
    ...params,
  });
  return data;
};

export const issueCertificateInheritance = async (uuid, params) => {
  const result = await apiClient.post(
    `/inheritance/${uuid}/issue-certificate`,
    { ...params },
    { responseType: "blob", metaData: { isNotificationDisabled: true } }
  );
  return result.data;
};

export const getTestamentList = async (params) => {
  try {
    const { data } = await apiClient.get(`/inheritance/testament-list`, {
      params,
    });
    return data;
  } catch (e) {
    console.error("getTestamentList failed", e);
  }
};
